module.exports = __webpack_public_path__ + "static/media/saved.50e57a4a.svg";